var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLogoCircle = function SvgLogoCircle(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_2322_59939)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#002864"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.00003 31L28.1471 11.8529L30.5661 18.7003C30.5661 18.7003 31.9616 22.5148 29.7473 24.7292C27.5329 26.9435 25.6351 29.8834 22.5833 29.8834C19.5316 29.8834 10.2655 29.7349 9.00003 31Z",
    fill: "#3336BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.00003 31L28.1471 11.8529L21.2997 9.43388C21.2997 9.43388 17.4852 8.03839 15.2708 10.2528C13.0565 12.4671 10.1166 14.365 10.1166 17.4167C10.1166 20.4684 10.2655 29.7349 9.00003 31Z",
    fill: "url(#paint0_linear_2322_59939)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1475 11.8529L9.00037 31C10.2733 29.7368 13.8828 21.5568 15.1009 18.857C16.319 16.1571 18.8587 14.1458 21.0847 11.9366C23.3108 9.7274 24.9783 10.4911 25.0662 10.5314L28.1475 11.8529Z",
    fill: "#959FE5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_2322_59939",
    x: -32,
    y: -32,
    width: 104,
    height: 104,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "BackgroundImageFix",
    stdDeviation: 16
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2322_59939"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_backgroundBlur_2322_59939",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2322_59939",
    x1: 5.33788,
    y1: 27.338,
    x2: 24.4847,
    y2: 8.19039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC882"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1121,
    stopColor: "#FEC986"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2286,
    stopColor: "#FACA93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3471,
    stopColor: "#F3CDA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.467,
    stopColor: "#EAD0C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5869,
    stopColor: "#DED5EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6164,
    stopColor: "#DBD6F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C8FFFF"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLogoCircle);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,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";